import { createFileRoute } from "@tanstack/react-router"
import { CustomersList } from "modules/customers/components/List"
import { PaginationSearchSchema } from "modules/shared/hooks/usePagination"
import { SearchQuerySchema } from "modules/shared/hooks/useSearchQuery"
import { CustomersFilterBySchema, CustomersSortSchema } from "schema"
import { z } from "zod"

// eslint-disable-next-line react-refresh/only-export-components
export const CustomerListSearchSchema = PaginationSearchSchema.extend(SearchQuerySchema.shape)
  .extend(CustomersSortSchema.shape.sortBy.unwrap().shape)
  .extend(CustomersFilterBySchema.shape)

export const Route = createFileRoute("/_base/_auth/customers/list")({
  component: CustomersList,
  validateSearch: (search: Partial<z.infer<typeof CustomerListSearchSchema>>) => {
    const filterBy =
      typeof search.filterBy === "object" &&
      search.filterBy !== null &&
      !Array.isArray(search.filterBy)
        ? search.filterBy
        : {}
    return CustomerListSearchSchema.parse({ ...search, filterBy })
  },
})
